/** @file Picks the nearest point (mesh vertex, bone joint, socket point) within a screen-pixel radius. */
import { trig } from '@pose2d/math/trig';
import type { Vec2 } from '@pose2d/math/types';
import type { Camera } from '@pose2d/geometry/types';
import { projectPoint } from './_internal/projectPoint';

/** World points stored as (x, y) pairs at coords[i * stride + offset] for i < count. */
export interface PointSet {
  coords: ArrayLike<number>;
  stride: number;
  offset: number;
  count: number;
}

/** Index of the point nearest to screen (sx, sy) within radiusPx, or -1; ties go to the later index. */
export function pickPoint(points: PointSet, camera: Camera, sx: number, sy: number, radiusPx: number): number {
  const s: Vec2 = [0, 0];
  let best = -1;
  let bestD = radiusPx;
  for (let i = 0; i < points.count; i++) {
    projectPoint(points, i, camera, s);
    const d = trig.hypot(s[0] - sx, s[1] - sy);
    if (d <= bestD) {
      best = i;
      bestD = d;
    }
  }
  return best;
}
